/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
{
  function triggerDeliveryPopup() {
    document.getElementById("delivery-popup").setAttribute("aria-hidden", "false");
  }
  var deliveryPopupTriggers = document.getElementsByClassName("delivery-popup-trigger");
  for (var i = 0; i < deliveryPopupTriggers.length; i++) {
    deliveryPopupTriggers[i].addEventListener('click', triggerDeliveryPopup, false);
  }
  document.getElementById("delivery-popup-close").addEventListener("click",function () {
    document.getElementById("delivery-popup").setAttribute("aria-hidden", "true");
  }, false);
  
  function triggerDoubletimePopup() {
    document.getElementById("doubletime-popup").setAttribute("aria-hidden", "false");
  }
  var doubletimePopupTriggers = document.getElementsByClassName("doubletime-popup-trigger");
  for (var i = 0; i < doubletimePopupTriggers.length; i++) {
    doubletimePopupTriggers[i].addEventListener('click', triggerDoubletimePopup, false);
  }
  document.getElementById("doubletime-popup-close").addEventListener("click",function () {
    document.getElementById("doubletime-popup").setAttribute("aria-hidden", "true");
  }, false);
}
/* ------------------------------------------------------------
   Open Double Time Popup
   ------------------------------------------------------------
   Triggers:
   - Any link with href="#doubletime-popup" (Slideshow-Banner)
   - Any element with class .doubletime-popup-trigger
   ------------------------------------------------------------ */
(function () {
  function openDoubletimePopup() {
    var popup = document.getElementById('doubletime-popup');
    if (!popup) return;

    // 1. ARIA-Toggle (Standard-Theme-Pattern)
    popup.setAttribute('aria-hidden', 'false');

    // 2. Sichtbarkeits-Klassen (deckt mehrere Theme-Konventionen ab)
    popup.classList.add('is-visible', 'is-open', 'modal--active');

    // 3. Body / HTML sperren gegen Scrollen
    document.documentElement.classList.add('no-scroll', 'modal-is-active');
    document.body.classList.add('no-scroll', 'modal-is-active');

    // 4. Theme-Popup-API falls vorhanden
    if (window.theme && typeof window.theme.openPopup === 'function') {
      try { window.theme.openPopup('doubletime-popup'); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      'a[href$="#doubletime-popup"], a[href="#doubletime"], .doubletime-popup-trigger'
    );
    if (!trigger) return;
    e.preventDefault();
    openDoubletimePopup();
  });
})();